export enum ClientsidePaymentMethodType
{
    Card
}

export class ClientsidePaymentMethod
{
    type : ClientsidePaymentMethodType = 0;
    masked = "";
    expiration = "";
    cardType = "";
    token = "";
    activeSubCard = false;
}

export enum ClientSubscriptionStatus
{
    Active = 0,
    Canceled = 1,
    Expired = 2,
    PastDue = 3,
    Pending = 4,
    Unrecognized = 255
}

export class ClientSubscription
{
    constructor(value : {planId : string, nextBillingDateStr : string, paidThroughDateStr : string, status : ClientSubscriptionStatus, nextBillAmount : number, expiring : boolean})
    {
        this.planId = value.planId;
        this.nextBillingDateStr = value.nextBillingDateStr;
        this.paidThroughDateStr = value.paidThroughDateStr;
        this.status = value.status;
        this.nextBillAmount = value.nextBillAmount;
        this.expiring = value.expiring;
    }

    planId = "";
    private nextBillingDateStr = "";
    private paidThroughDateStr = "";
    status = ClientSubscriptionStatus.Unrecognized;
    nextBillAmount = 0;
    expiring = false;

    get nextBillingDate()
    {
        return new Date(this.nextBillingDateStr);
    }

    get paidThroughDate()
    {
        return new Date(this.paidThroughDateStr);
    }
}